import { navLinks } from '@/mocks/home';

const tips = [
  { icon: 'ri-links-line', text: '只从本页提供的线路进入官网' },
  { icon: 'ri-forbid-2-line', text: '不点击来源不明的转发链接' },
  { icon: 'ri-bookmark-3-line', text: '收藏本页，地址变化随时可查' },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-900 pb-8 pt-16 text-background-50 dark:text-foreground-950">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50 font-heading text-lg font-bold text-primary-800">
                黑
              </span>
              <span className="font-heading text-lg font-bold">黑料官网</span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-background-200 dark:text-foreground-700">
              官方访问指引站，为你实时同步可用入口、备用地址与换地址说明。遇到打不开时，回到这里就能找到答案。
            </p>
            <span className="mt-6 inline-flex items-center gap-2 rounded-full border border-background-50/25 px-3 py-1.5 text-xs text-background-100 dark:border-foreground-950/25 dark:text-foreground-800">
              <span className="h-1.5 w-1.5 animate-pulse-dot rounded-full bg-accent-400"></span>
              线路监测运行中
            </span>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-bold tracking-wide">页面导航</h4>
            <ul className="mt-5 space-y-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="cursor-pointer text-sm text-background-200 transition-colors duration-200 hover:text-background-50 dark:text-foreground-700 dark:hover:text-foreground-950"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="#channels"
                  className="cursor-pointer text-sm text-background-200 transition-colors duration-200 hover:text-background-50 dark:text-foreground-700 dark:hover:text-foreground-950"
                >
                  获取最新地址
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-sm font-bold tracking-wide">访问提示</h4>
            <ul className="mt-5 space-y-3">
              {tips.map((tip) => (
                <li key={tip.text} className="flex items-start gap-2.5">
                  <i className={`${tip.icon} mt-0.5 text-base text-accent-300`}></i>
                  <span className="text-sm leading-relaxed text-background-200 dark:text-foreground-700">
                    {tip.text}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 rounded-lg border border-background-50/15 bg-background-50/5 p-5 dark:border-foreground-950/15">
          <p className="text-xs leading-relaxed text-background-200 dark:text-foreground-700">
            免责说明：本页仅提供访问指引与线路状态说明，不存储、不展示任何第三方内容。请遵守所在地区的法律法规，通过正规渠道使用网络服务；如遇可疑链接或仿冒站点，请勿点击并回到本页使用官方线路。
          </p>
        </div>

        <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-300 dark:text-foreground-800">
            © 2026 黑料官网 访问指引站 · 保留所有权利
          </p>
          <p className="text-xs text-background-300 dark:text-foreground-800">
            地址实时同步 · 访问异常请刷新本页
          </p>
        </div>
      </div>
    </footer>
  );
}